// src/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ element }) => {
  const token = localStorage.getItem('authToken');
  const location = useLocation();
  if (token) {
    return element;
  }
  const next = location.pathname + location.search;
  return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
};

export default ProtectedRoute;
